@let _options = options();

@if (_options.closeButton) {
  <button (click)="remove()" type="button" class="toast-close-button" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
}

@if (title()) {
  <div [class]="_options.titleClass" [attr.aria-label]="title()">
    {{ title() }}

    @if (duplicatesCount) {
      <ng-container>[{{ duplicatesCount + 1 }}]</ng-container>
    }
  </div>
}

@if (message()) {
  @if (_options.enableHtml) {
    <div role="alert" [class]="_options.messageClass" [innerHTML]="message()"></div>
  } @else {
    <div role="alert" [class]="_options.messageClass" [attr.aria-label]="message()">
      {{ message() }}
    </div>
  }
}

@if (_options.progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width() + '%'"></div>
  </div>
}
